"use strict";

var root = "StudentLoanEvent.";

var StudentLoanEvents = {
    CONTINUE_CLICKED: root + "commonbond_studentLoan_continue_clicked_event",
    CANCEL_CLICKED: root + "commonbond_studentLoan_cancel_clicked_event"
};

export default StudentLoanEvents;
